import { CreateRailTrackDto, RailTrackDto, RailTracksApi } from '@storage/app/api'
import { AxiosPromise } from 'axios'

export class RailTracksService {
  constructor(private api: RailTracksApi) {}

  async getAll(): Promise<Array<RailTrackDto>> {
    const { data: railTracks } = await this.api.railTracksGetAll()
    return railTracks
  }

  async create(createRailTrackDto: CreateRailTrackDto): Promise<RailTrackDto> {
    const { data: railTrack } = await this.api.railTracksCreate({
      createRailTrackDto,
    })
    return railTrack
  }

  async update(railTrackDto: RailTrackDto): Promise<RailTrackDto> {
    const { data: railTrack } = await this.api.railTracksUpdate({
      railTrackDto,
    })
    return railTrack
  }

  async isNameUnique(name: string, id?: string): AxiosPromise<boolean> {
    return await this.api.railTracksIsUnique({
      name,
      id,
    })
  }

  async delete(id: string) {
    await this.api.railTracksDelete({ id })
  }
}
